import { baseTheme } from '@/theme/index';
import { MOONColorTheme, MOONTheme } from './IThemeConfig';

const lightMoonColors: MOONColorTheme = {
    avatar: {
        blue_100: '#CCDBFD',
        blue_200: '#ABC4FF',
        blue_50: '#CAE9FF',
        green_100: '#D1EBC5',
        green_200: '#9EE37D',
        grey: '#DADCE1',
        orange: '#FFAA86',
        red: '#FF928E',
        violet: '#B8A5FF',
        yellow: '#FFBD2E'
    },
    palette: {
        grey_100: '#F8F9FA',
        grey_200: '#F5F5F5',
        grey_250: '#F1F1F1',
        grey_300: '#E9E9E9',
        grey_400: '#E9ECEF',
        grey_450: '#DADCE1',
        grey_500: '#D1D1D6',
        grey_600: '#959DA6',
        grey_650: '#636970',
        grey_700: '#5B5B5B',
        grey_800: '#4A5056',
        grey_900: '#131313',

        text_grey_600: '#959EA6',

        white: '#FFF',

        green_100: '#D5E9DC',
        green_200: '#A4D7B5',
        green_250: '#97C6A7',
        green_300: '#59A774',

        yellow_100: '#FCF2C8',
        yellow_200: '#FCDF7B',
        yellow_300: '#EEBA01',
        yellow_400: '#FFBD2E',

        red_100: '#FDD2CF',
        red_200: '#FFA39C',
        red_300: '#F94C40',
        red_400: '#E51A0C',

        orange_100: '#FBDDD2',
        orange_200: '#FFA685',
        orange_300: '#F1794D',

        blue_50: '#F2F6FB',
        blue_100: '#E6EEF8',
        blue_200: '#DDECFF',
        blue_300: '#A8CAF3',
        blue_350: '#A5BDDA',
        blue_400: '#7CADEB',
        blue_500: '#4475B3',
        blue_600: '#3A608F',
        blue_700: '#2B5283',

        mint_300: '#40A69F',

        violet_400: '#B8A5FF'
    },
    icon: {
        primary: '#4A5056'
    },
    optionalPrimary: {
        hover: '#F2F6FB',
        main: '#7CADEB'
    },
    secondary: {
        focused: '#73E3DC',
        hover: '#BDF8F4',
        main: '#94DFDA'
    },
    background: '#F4F4F4',
    overlay: '#4646465c',
    primary: {
        main: '#DDECFF',
        hover: '#E6EEF8',
        focused: '#A8CAF3'
    },
    deviceStatus: {
        active: '#97C6A7',
        offline: '#F78F88',
        hanged: '#FFC56F',
        lowhash: '#F9E8AB'
    },
    taskStatus: {
        todo: '#D1D1D6',
        in_progress: '#7CADEB',
        on_hold: '#FFC56F',
        done_7d: '#97C6A7',
        overdue: '#F78F88'
    },
    dashboardHrStatus: {
        dead: '#F78F88',
        broken: '#FFC56F',
        underhash: '#F9E8AB'
    },
    massActionStatus: {
        successful: '#97C6A7',
        failed: '#F78F88'
    },
    deviceChart: {
        active: '#97C6A7',
        offline: '#F78F88',
        lowhash: '#FFC700',
        hanged: '#FFC56F'
    },
    shadow: {
        sm: '0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 6px 6px -6px rgba(0, 0, 0, 0.16)',
        md: '0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 12px 12px -6px rgba(0, 0, 0, 0.16)',
        lg: '0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 8px 24px -6px rgba(0, 0, 0, 0.16)',
        xl: '0px 0px 1px 0px rgba(0, 0, 0, 0.20), 0px 0px 32px -8px rgba(0, 0, 0, 0.12), 0px 32px 32px -8px rgba(0, 0, 0, 0.08)'
    }
};

export const lightTheme: MOONTheme = {
    ...baseTheme,
    colors: lightMoonColors
};
